import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  unit_act : 0,
  unit : 0,
  track : 0,
  play : false,
  rewind : false,
  repeat : true,
  duration_time : '00:00',
  current_time : '00:00',
  range : 0,
};

const track = createSlice({
  name : "track",
  initialState,
  reducers : {
    resetTrack : () => initialState,
    setUnitAct(state, action) {
      state.unit_act = action.payload;
    },
    setUnit(state, action) {
      state.unit = action.payload;
    },
    setTrack(state, action) {
      state.track= action.payload;
    },
    setPlay(state, action) {
      state.play = action.payload;
    },
    setRewind(state, action) {
      state.rewind = action.payload;
    },
    setRepeat(state, action) {
      state.repeat = action.payload;
    },
    setDurationTime(state, action) {
      let minute = Math.floor(action.payload / 60);
      minute = minute < 10 ? "0" + minute.toString() : minute;
      
      let second = parseInt(action.payload - minute * 60);
      second = second < 10 ? "0" + second.toString() : second;

      state.duration_time = minute + ":" + second;
    },
    setCurrentTime(state, action) {
      let minute = Math.floor(action.payload / 60);
      minute = minute < 10 ? "0" + minute.toString() : minute;
      
      let second = parseInt(action.payload - minute * 60);
      second = second < 10 ? "0" + second.toString() : second;

      state.current_time = minute + ":" + second;
    },
    setRange(state, action) {
      state.range = action.payload;
    }
  }
});

export const { resetTrack, setUnitAct, setUnit, setTrack, setPlay, setRewind, setRepeat, setDurationTime, setCurrentTime, setRange } = track.actions;
 
export default track;